import request from '@/utils/request'


// 获取分页医院列表
export function getHospitals (data) {
    return request({
        url: '/api/hospital/page',
        method: 'get',
        params: { ...data, pcReqFlag: true }
    })
}

// 获取PC端疾病列表
export function getDisease (data) {
    return request({
        url: '/api/disease-type/page',
        method: 'get',
        params: data,
    })
}


// 获取科室列表
export function getDepts (data) {
    return request({
        url: '/api/dept/page',
        method: 'get',
        params: data
    })
}


// 获取医生列表
export function getDoctors (data) {
    return request({
        url: '/api/doctor/page',
        method: 'get',
        params: data
    })
}

// 获取分页广告列表
export function getAdverts (data) {
    return request({
        url: '/api/advert/page',
        method: 'get',
        params: data
    })
}


// 获取分页资讯列表
export function getArticle (data) {
    return request({
        url: '/api/article/page',
        method: 'get',
        params: data
    })
}



// 获取身体部位
// 智能导诊
export function getBodyInfo (data) {
    return request({
        url: '/api/body',
        method: 'get',
        params: data
    })
}


// 根据身体id获取症状类别列表
// 智能导诊
export function byPartId (data) {
    return request({
        url: '/api/symptom/byPartId',
        method: 'get',
        params: data
    })
}

// 根据症状id获取症状列表
// 智能导诊
export function getSympById (data) {
    return request({
        url: '/api/symptom/getSympById',
        method: 'get',
        params: data
    })
}

// 根据症状id获取推荐科室
// 智能导诊
export function getDeptBySympId (data) {
    return request({
        url: '/api/symptom/getDeptBySympId',
        method: 'get',
        params: data
    })
}


// 智能导诊 获取导诊链接
export function getPcZndzUrl (data) {
    return request({
        url: '/api/appmenu/getPcZndzUrl',
        method: 'get',
        params: data
    })
}


// 健康档案浏览器
export function getPcJkdaUrl (data) {
    return request({
        url: '/api/record/getDasHealthRecordParams',
        method: 'get'
    })
}





